import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { MessageService } from 'primeng/api';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interceptor for S3 presigned URLs
    if (req.headers.has('X-Skip-Interceptor')) {
      return next.handle(req);
    }

    const requestId = uuidv4();

    if (req.url.includes('/graphql')) {
      const modifiedReq = req.clone({
        setHeaders: {
          'X-Request-Id': requestId
        }
      });

      return next.handle(modifiedReq).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const body = event.body;
            if (body?.errors && Array.isArray(body.errors)) {
              body.errors
                .filter((err: any) => err.extensions?.classification === 'FORBIDDEN')
                .forEach((err: any) => {
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: err.message || 'You do not have permission to perform this action',
                    life: 5000
                  });
                });
            }
          }
          return event;
        })
      );
    }

    return next.handle(req);
  }
}